// delegating.telephony.provider.ts

import { Injectable } from '@angular/core';
import { AuthenticationService } from '@app/core';
import { TelephonyProvider } from './telephony.provider';
import { TwilioTelephonyProvider } from './twilio/twilio.telephony.provider';
import { IbexTelephonyProvider } from './ibex/ibex.telephony.provider';
import { MessagingProvider } from './telephony.provider';
import { VoiceProvider } from './telephony.provider';
import { InsightProvider } from './telephony.provider';

@Injectable()
export class DelegatingTelephonyProvider extends TelephonyProvider {
  private actualProvider: TelephonyProvider | null = null;

  constructor(
    private auth: AuthenticationService,
    private twilio: TwilioTelephonyProvider,
    private ibex: IbexTelephonyProvider
  ) {
    // Temporarily pass nulls to base class
    super();
  }

  private get provider(): TelephonyProvider {
    if (!this.actualProvider) {
      const providerKey = this.auth.authData?.ClientInfo?.Provider?.TelephoneProvider?.toLowerCase();
      this.actualProvider = providerKey === 'ibex' ? this.ibex : this.twilio;
    }
    return this.actualProvider;
  }

  override name(): string {
    return this.provider.name();
  }

  override init(lifecycle?: any, ...args: any[]): void {
    this.provider.init(lifecycle, ...args);
  }

  override get messaging(): MessagingProvider {
    return this.provider.messaging;
  }

  override get voice(): VoiceProvider {
    return this.provider.voice;
  }

  override get insight(): InsightProvider {
    return this.provider.insight;
  }
}
